import { computed, watch } from 'vue'
import { useOrientation } from './useOrientation';
import { useMeetings } from './useMeetings';

export function useMeetingClasses(container: HTMLElement | null = null) {

    const meetingStore = useMeetings();
    const meeting = computed(() => meetingStore.getMeeting().value)

    const orientation = useOrientation()

    const isPrimaryCamera = computed(() => meeting.value.isPrimaryCamera)

    const appClasses = computed(() => ({ 
        'mobile': meeting.value.isMobileDevice, 
        'desktop': meeting.value.isDesktopDevice,
        'desktop-like-mobile': meeting.value.isDesktopLikeMobileDevice,
        'landscape': orientation.isLandscape.value,
        'portrait': orientation.isPortrait.value, 
        'screenshare-active': meeting.value.isAnyScreenShareActive,
        'my-screen-share-active': meeting.value.iAmScreenSharing,
        'primary-camera': isPrimaryCamera.value,
        'not-primary-camera': isPrimaryCamera.value === false,
    }))

    container = container || document.body;

    watch(appClasses, (newClasses, oldClasses) => {
        console.log('app classes changed', newClasses)
        if(oldClasses) {
            container.classList.remove(...Object.keys(oldClasses))
        }
        Object.keys(newClasses).forEach((key) => {
            if ((newClasses as any)[key]) {
                container.classList.add(key)
            }
        })
    }, { immediate: true })
    
}